import React from 'react';
import Localize from 'react-intl-universal';

import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

import StyledBoxCenter from '@components/StyledBoxCenter/StyledBoxCenter';
import StyledConfirmTypography from '@components/StyledConfirmTypography/StyledConfirmTypography';
import StyledErrorIcon from '@components/StyledErrorIcon/StyledErrorIcon';

const StyledContainer = styled(Container)({
  minHeight: 'calc(100vh - 5.4rem)'
});

const BadUrlMessage = () => {
  return (
    <StyledContainer>
      <StyledBoxCenter>
        <StyledErrorIcon />
        <StyledConfirmTypography>{Localize.get('App.badUrl')}</StyledConfirmTypography>
      </StyledBoxCenter>
    </StyledContainer>
  );
};

export default BadUrlMessage;
